import {IBaseFetchOptions, IBaseParameters, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	PUT_ABANDONEDCART: {
		path: '/basket/upsertAbandonedCart',
		method: 'PUT',
	},
};

export type IPutAbandonedCartOptions = IBaseFetchOptions & {
	parameters: IBaseParameters;
};
